const SocialNetwork = () => {
  const social_accounts = [
    {
      id: "1",
      href: "https://www.linkedin.com/in/riaratnasari/",
      icon: "fa-linkedin",
      delay: 200,
    },
    {
      id: "2",
      href: "https://github.com/riaars",
      icon: "fa-github",
      delay: 400,
    },
    {
      id: "3",
      href: "https://twitter.com/riaa_rs",
      icon: "fa-twitter",
      delay: 600,
    },
  ];
  return (
    <div className="social-network__container">
      {social_accounts.map((social_account) => (
        <button
          key={social_account.id}
          data-aos="fade-up-right"
          data-aos-delay={social_account.delay}
          data-aos-duration="800"
          className="btn-social-network"
        >
          <a href={social_account.href} target="blank">
            <i
              className={`fab ${social_account.icon} icon-social-network`}
              aria-hidden="true"
            ></i>
          </a>
        </button>
      ))}
    </div>
  );
};

export default SocialNetwork;
